// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fa-hidden {\n    color: transparent;\n}\n\n.menu-card-product-options-indicator .fa {\n    width: 1em;\n}\n\n.menu-card-product-item {\n    line-height: 1em;\n}\n\n.menu-card-product-item .product-name {\n    line-height: 1em;\n    vertical-align: middle;\n}\n\n.menu-card-product-item .product-state-text {\n    font-size: 0.8em;\n    color: #dc3545;\n}\n", ""]);
// Exports
module.exports = exports;
